import { history, useIntl } from '@umijs/max';
import { Button, Result } from 'antd';
import React from 'react';

const NoAccessPage: React.FC = () => {
  const intl = useIntl();

  return (
    <Result
      status="403"
      title="403"
      subTitle={intl.formatMessage({ 
        id: 'pages.403.subTitle', 
        defaultMessage: 'Sorry, you are not authorized to access this page.' 
      })}
      extra={
        <Button type="primary" onClick={() => history.push('/')}>
          {intl.formatMessage({ 
            id: 'pages.403.buttonText', 
            defaultMessage: 'Back Home' 
          })}
        </Button>
      }
    />
  );
};

export default NoAccessPage;

